@if (!isNotAuthPage()) {
<div id="footer" class="bg-primary text-white pt-[5rem] pb-[2rem]">
    <div class="container mx-auto px-5">
        <div class="lg:flex flex-wrap items-start">
            <div class="xl:w-1/3 pe-[5rem]  w-full mb-5">
                <img routerLink="['/']" class=" logo mb-5 lg:me-[5rem] sm:me-[4rem] " width="200px"
                    src="Images/logo-white.png" alt="">
                <p>Exemplix isn’t just another study website. It’s a smart learning ecosystem built for students who
                    want clarity, confidence, and results.</p>
            </div>
            <div class="lg:flex hidden xl:w-2/3 w-full flex-wrap items-start">
                <div class="lg:w-1/4 w-1/2 mb-5">
                    <ul>
                        <li class="font-semibold mb-2">Resources</li>
                        <li routerLink="['/']" class="cursor-pointer mb-2">Home</li>
                        <li routerLink="['/']" class="cursor-pointer mb-2">Landing</li>
                        <li routerLink="['/']" class="cursor-pointer mb-2">Blog</li>
                        <li routerLink="['/']" class="cursor-pointer mb-2">Help Center</li>
                        <li routerLink="['/']" class="cursor-pointer mb-2">Landing</li>
                        <li routerLink="['/']" class="cursor-pointer mb-2">Blog</li>
                        <li routerLink="['/']" class="cursor-pointer mb-2">Help Center</li>
                        <li routerLink="['/']" class="cursor-pointer mb-2">Contact Us</li>
                    </ul>
                </div>
                <div class="lg:w-1/4 w-1/2 mb-5">
                    <ul>
                        <li class="font-semibold mb-2">Member</li>
                        <li routerLink="['/']" class="cursor-pointer mb-2">Login</li>
                    </ul>
                </div>
                <div class="lg:w-1/4 w-1/2 mb-5">
                    <ul>
                        <li class="font-semibold mb-2">Company</li>
                        <li routerLink="['/']" class="cursor-pointer mb-2">Home</li>
                        <li routerLink="['/']" class="cursor-pointer mb-2">Landing</li>
                        <li routerLink="['/']" class="cursor-pointer mb-2">Blog</li>
                        <li routerLink="['/']" class="cursor-pointer mb-2">Help Center</li>
                        <li routerLink="['/']" class="cursor-pointer mb-2">Landing</li>
                        <li routerLink="['/']" class="cursor-pointer mb-2">Blog</li>
                        <li routerLink="['/']" class="cursor-pointer mb-2">Help Center</li>
                        <li routerLink="['/']" class="cursor-pointer mb-2">Contact Us</li>
                    </ul>
                </div>

                <div class="lg:w-1/4 w-1/2 mb-5">
                    <ul>
                        <li class="font-semibold mb-2">Subjects</li>
                        <li routerLink="['/']" class="cursor-pointer mb-2">Home</li>
                        <li routerLink="['/']" class="cursor-pointer mb-2">Landing</li>
                        <li routerLink="['/']" class="cursor-pointer mb-2">Blog</li>
                        <li routerLink="['/']" class="cursor-pointer mb-2">Help Center</li>
                        <li routerLink="['/']" class="cursor-pointer mb-2">Landing</li>
                        <li routerLink="['/']" class="cursor-pointer mb-2">Blog</li>
                        <li routerLink="['/']" class="cursor-pointer mb-2">Help Center</li>
                        <li routerLink="['/']" class="cursor-pointer mb-2">Contact Us</li>
                    </ul>
                </div>
            </div>

            <div class="lg:hidden block">
                <p-accordion value="0">
                    <p-accordion-panel value="0">
                        <p-accordion-header>Resources</p-accordion-header>
                        <p-accordion-content>
                            <ul>
                                <li routerLink="['/']" class="cursor-pointer mb-2">Home</li>
                                <li routerLink="['/']" class="cursor-pointer mb-2">Landing</li>
                                <li routerLink="['/']" class="cursor-pointer mb-2">Blog</li>
                                <li routerLink="['/']" class="cursor-pointer mb-2">Help Center</li>
                                <li routerLink="['/']" class="cursor-pointer mb-2">Landing</li>
                                <li routerLink="['/']" class="cursor-pointer mb-2">Blog</li>
                                <li routerLink="['/']" class="cursor-pointer mb-2">Help Center</li>
                                <li routerLink="['/']" class="cursor-pointer mb-2">Contact Us</li>
                            </ul>
                        </p-accordion-content>
                    </p-accordion-panel>

                    <p-accordion-panel value="1">
                        <p-accordion-header>Member</p-accordion-header>
                        <p-accordion-content>
                            <ul>
                                <li routerLink="['/']" class="cursor-pointer mb-2">Login</li>
                            </ul>
                        </p-accordion-content>
                    </p-accordion-panel>

                    <p-accordion-panel value="2">
                        <p-accordion-header>Company</p-accordion-header>
                        <p-accordion-content>
                            <ul>
                                <li routerLink="['/']" class="cursor-pointer mb-2">Home</li>
                                <li routerLink="['/']" class="cursor-pointer mb-2">Landing</li>
                                <li routerLink="['/']" class="cursor-pointer mb-2">Blog</li>
                                <li routerLink="['/']" class="cursor-pointer mb-2">Help Center</li>
                                <li routerLink="['/']" class="cursor-pointer mb-2">Landing</li>
                                <li routerLink="['/']" class="cursor-pointer mb-2">Blog</li>
                                <li routerLink="['/']" class="cursor-pointer mb-2">Help Center</li>
                                <li routerLink="['/']" class="cursor-pointer mb-2">Contact Us</li>
                            </ul>
                        </p-accordion-content>
                    </p-accordion-panel>

                    <p-accordion-panel value="3">
                        <p-accordion-header>Subjects</p-accordion-header>
                        <p-accordion-content>
                            <ul>
                                <li routerLink="['/']" class="cursor-pointer mb-2">Home</li>
                                <li routerLink="['/']" class="cursor-pointer mb-2">Landing</li>
                                <li routerLink="['/']" class="cursor-pointer mb-2">Blog</li>
                                <li routerLink="['/']" class="cursor-pointer mb-2">Help Center</li>
                                <li routerLink="['/']" class="cursor-pointer mb-2">Landing</li>
                                <li routerLink="['/']" class="cursor-pointer mb-2">Blog</li>
                                <li routerLink="['/']" class="cursor-pointer mb-2">Help Center</li>
                                <li routerLink="['/']" class="cursor-pointer mb-2">Contact Us</li>
                            </ul>
                        </p-accordion-content>
                    </p-accordion-panel>
                </p-accordion>
            </div>

        </div>
        <hr>
        <div class="pt-5 flex justify-between items-center">
            <p class="capitalize">&copy; copyright 2015-2025 all rights reserved</p>
            <div class="flex justify-between items-center">
                <a href="#">
                    <ng-icon class="me-2" name="bootstrapInstagram" />
                </a>
                <a href="">
                    <ng-icon class="me-2" name="bootstrapTiktok" />
                </a>
                <a href="">
                    <ng-icon class="" name="bootstrapBell" />
                </a>
            </div>
        </div>
    </div>
</div>
}